import PropTypes from "prop-types"
import React from "react"

import BasicPrice from "./BasicPrice"
import Discount from "./Discount"
import DiscountedPrice from "./DiscountedPrice"
import HorizontalRule from "./HorizontalRule"
import OriginalPrice from "./OriginalPrice"
import SectionHeading from "./SectionHeading"
import Subtotal from "./Subtotal"
import Tax from "./Tax"
import Total from "./Total"

const LineItem = ({ type, currency = "USD", ...passThroughProps }) => {
  const determineType = (type) => {
    switch (type) {
      case "price":
        return BasicPrice
      case "original_price":
        return OriginalPrice
      case "discounted_price":
        return DiscountedPrice
      case "subtotal":
        return Subtotal
      case "tax":
        return Tax
      case "total":
        return Total
      case "horizontal_rule":
        return HorizontalRule
      case "discount":
        return Discount
      case "section_heading":
        return SectionHeading
      default:
        return BasicPrice
    }
  }

  const PriceComponent = determineType(type)

  return <PriceComponent currency={currency} {...passThroughProps} />
}

LineItem.propTypes = {
  type: PropTypes.oneOf([
    "price",
    "original_price",
    "discounted_price",
    "subtotal",
    "tax",
    "total",
    "horizontal_rule",
    "discount",
    "section_heading",
  ]).isRequired,
  label: PropTypes.string,
  amount: PropTypes.number,
  suffix: PropTypes.string,
  source: PropTypes.string,
  loading: PropTypes.bool,
  currency: PropTypes.string,
  description: PropTypes.string,
  secondaryDescription: PropTypes.string,
  dates: PropTypes.string,
}

export default LineItem
